import { cn } from '@/ui/design-system/utils/cn';

export function PagePadding({ className, children }) {
    return (
        <div
            className={cn(
                'mx-auto max-w-[1100px] px-4 pt-2 pb-[100px]',
                className,
            )}
        >
            {children}
        </div>
    );
}
